/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceBreakdownLineItemDataSchema = z.object({
	description: z.string(),
	amount: z.number(),
})

export type InvoiceBreakdownLineItemDataSchema = z.infer<typeof invoiceBreakdownLineItemDataSchema>
